<template>
  <FormInput v-bind="props" not-rounded-left input-container-classes="flex items-center justify-center"
             :prefix="selectedPrefix" @update:modelValue="updateModelValue" @change="change">
    <template #near-input>
      <FormSelectDropdown class="-mr-1.5" not-rounded-right :options="prefixes" v-model="selectedPrefix"
                          :readonly="readonly" :class="dropdownWidthClass"/>
    </template>
  </FormInput>
</template>

<script setup>
import FormInput from "./FormInput.vue";
import FormSelectDropdown from "./FormSelectDropdown.vue";
import {ref} from "vue";

const emits = defineEmits(["update:modelValue", "change"]);
const props = defineProps({
  label: String,
  labelHint: String,
  placeholder: String,
  modelValue: String,
  type: String,
  required: Boolean,
  error: String,
  format: String,
  maxLength: Number,
  autocomplete: String,
  autofocus: Boolean,
  roundedFull: Boolean,
  readonly: Boolean,
  inputClasses: String,
  labelClasses: String,
  inputMode: String,
  prefixes: Array,
  defaultPrefix: String,
  dropdownWidthClass: {
    type: String,
    default: "w-32",
  },
});

const selectedPrefix = ref(props.defaultPrefix);

const updateModelValue = (value) => emits("update:modelValue", value);
const change = (value) => emits("change", value);
</script>
